<template>
  <div class="m-wrap m-wap" v-if="extras1 && extras1.formBgWap">
    <Banner :seminarInfo="seminarInfo" />
    <!--<div class="venue">-->
    <!--<a v-if="extraItem.extras('signupfont.model').length>0" v-show="formInfo.identity == 1" @click="togoVerify()" class="goto-venue font">-->
    <!--{{ extras | extra("signupfont.model") }}-->
    <!--</a>-->
    <!--</div>-->
    <FormStatus
      v-if="isTrackClosedMessage"
      :status="'over'"
      :platform="platform"
    ></FormStatus>
    <div
      v-else-if="preview || formInfo.status == 1 || isSetting == 1"
      :style="{
        background:
          extras.formFieldBg.colorOrBg == 'color'
            ? extras.formFieldBg.color
            : 'url(\'' + extras.formFieldBg.src.replace(/'/g, '\\\'') + '\')',
        'background-size': '100% 100%',
      }"
    >
      <h4
        class="title"
        :class="extras.formTitle.textAlign"
        v-if="extras.formTitle.display == 1"
        :style="{ 'letter-spacing': extras.formTitle.wordWidth + 'px' }"
      >
        {{ extras.formTitle.title }}
      </h4>
      <CField
        class="field-wrap"
        :formData="formData"
        :platform="platform"
        :rulesJump.sync="rulesJump"
        ref="formRef"
      />
      <div class="bottom">
        <a-button
          class="submit"
          type="primary"
          @click="submit()"
          :disabled="isSubmitting"
          :style="{
            color:
              extras.submitButton.buttonTextStyle == 'custom'
                ? extras.submitButton.fontColor
                : '',

            'font-style':
              extras.submitButton.buttonTextStyle == 'custom'
                ? extras.submitButton.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-weight':
              extras.submitButton.buttonTextStyle == 'custom'
                ? extras.submitButton.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
        >
          {{ extras | extra("submitButton.text") }}
        </a-button>
        <a-button
          class="verify"
          v-if="extras.seminarButton && extras.seminarButton.display == 1"
          v-show="formInfo.identity == 1"
          @click="togoVerifyNew()"
          :disabled="isSubmitting"
        >
          {{ extras | extra("seminarButton.text") }}
        </a-button>
      </div>
    </div>

    <FormStatus
      v-else
      :status="formInfo.status == 0 ? 'nostart' : 'over'"
      :platform="platform"
    ></FormStatus>
    <div class="bottom" v-if="isTrackClosedMessage">
      <a-button
        class="verify"
        v-if="extras.seminarButton && extras.seminarButton.display == 1"
        v-show="formInfo.identity == 1"
        @click="togoVerifyNew()"
        :disabled="isSubmitting"
      >
        {{ extras | extra("seminarButton.text") }}
      </a-button>
    </div>
    <!--<Card :tenantId="tenantId"></Card>-->
  </div>
</template>

<script>
import Banner from "@/components/BannerNew.vue";
import CField from "@/components/CFieldNew.vue";
import FormStatus from "@/components/FormStatusNew.vue";

import mixinMeeting from "../../mixin/meetingNew.js";
import mixinConfig from "../../mixin/configNew.js";
import mixin from "../../mixin/form.js";
//import Card from "../../../stempcore/src/core/components/common/Card"

export default {
  name: "WapIndex",
  mixins: [mixinMeeting, mixinConfig, mixin],
  components: {
    Banner,
    CField,
    FormStatus,
    //    Card,
  },

  data() {
    return {
      platform: "wap",
    };
  },
  computed: {
    extras1() {
      return this.$store.state.extras;
    },
  },
};
</script>
